import {
  SHOW_WARN_POPUP,
  HIDE_WARN_POPUP,
  SET_WARN_POPUP_TEXT,
  SET_WARN_POPUP_USERID,
} from './types';

export const showWarnPopup = (userId) => ({
  type: SHOW_WARN_POPUP,
  payload: { userId },
});

export const hideWarnPopup = () => ({
  type: HIDE_WARN_POPUP,
});

export const setWarnPopupText = (text) => ({
  type: SET_WARN_POPUP_TEXT,
  payload: text,
});

export const setWarnPopupUserId = (userId) => ({
  type: SET_WARN_POPUP_USERID,
  payload: userId,
});
